<script>
import XYZ from 'ol/source/XYZ'

export default {
  name: 'ol-source-xyz',

  inject: ['getLayer'],

  props: {
    url: {
      type: String,
      required: true
    },

    crossOrigin: {
      type: String,
      default: 'Anonymous'
    }
  },

  watch: {
    url (newVal) {
      this.xyz.setUrl(newVal)
      this.xyz.refresh()
    }
  },

  data () {
    return {
      xyz: null
    }
  },

  created () {
    this.xyz = new XYZ({
      url: this.url,
      crossOrigin: this.crossOrigin
    })

    this.getLayer(layer => {
      layer.setSource(this.xyz)
    })
  },

  beforeDestroy () {
    this.xyz = null
  },

  render () {
    return null
  }
}
</script>
